var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3915 9C17.3915 13.6973 13.6074 17.5 8.94576 17.5C4.28414 17.5 0.5 13.6973 0.5 9C0.5 4.30273 4.28414 0.5 8.94576 0.5C13.6074 0.5 17.3915 4.30273 17.3915 9Z",
    stroke: "#2A3790"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_11252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 9C17.4999 13.6973 13.7158 17.5 9.05416 17.5C4.39254 17.5 0.608398 13.6973 0.608398 9C0.608398 4.30273 4.39254 0.5 9.05416 0.5C13.7158 0.5 17.4999 4.30273 17.4999 9Z",
    stroke: "#2A3790"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1302_11252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8595 11.1419H11.2186V10.2648H6.8595V11.1419Z",
    fill: "#2A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2186 9.38761H6.8595V8.5105H11.2186V9.38761Z",
    fill: "#2A3790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8595 7.63346H8.60315V6.75635H6.8595V7.63346Z",
    fill: "#2A3790"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42334 4.125C6.07651 4.125 5.74388 4.26361 5.49863 4.51035C5.25338 4.75709 5.1156 5.09173 5.1156 5.44067V11.5805C5.1156 11.9294 5.25338 12.264 5.49863 12.5108C5.74388 12.7575 6.07651 12.8961 6.42334 12.8961H11.6543C12.0011 12.8961 12.3338 12.7575 12.579 12.5108C12.8243 12.264 12.962 11.9294 12.962 11.5805V7.19489C12.962 6.38071 12.6406 5.59987 12.0683 5.02415C11.4961 4.44843 10.7199 4.125 9.91065 4.125H6.42334ZM6.42334 5.00211H9.47474V7.19489H12.0902V11.5805C12.0902 11.6968 12.0443 11.8083 11.9625 11.8906C11.8808 11.9728 11.7699 12.019 11.6543 12.019H6.42334C6.30773 12.019 6.19685 11.9728 6.1151 11.8906C6.03335 11.8083 5.98743 11.6968 5.98743 11.5805V5.44067C5.98743 5.32436 6.03335 5.21281 6.1151 5.13056C6.19685 5.04832 6.30773 5.00211 6.42334 5.00211ZM10.3466 5.04597C10.6892 5.11659 11.0099 5.26897 11.2818 5.49029C11.5537 5.71162 11.7687 5.99541 11.9089 6.31778H10.3466V5.04597Z",
    fill: "#2A3790"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_11252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8915,
    height: 18,
    fill: "white",
    transform: "translate(0.108398)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1302_11252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.69124,
    height: 9.75,
    fill: "white",
    transform: "translate(4.2085 4.125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.8633b8d5c028af6b07d9cd71a3c0a0bc.svg";
export { ForwardRef as ReactComponent };